module.exports = __webpack_public_path__ + "static/down-arrow-2-15a0f7cb0f1b022c025d050efe79cadf.svg";